// Logotipo Infotravel.
//
// O arquivo vive em public/logo.svg, copiado do site institucional em vez de
// referenciado por URL: assim a subnav não depende de infotravel.com.br estar no
// ar, não paga DNS + TLS para um terceiro domínio, e o logo entra no mesmo cache
// do resto dos estáticos. Para atualizar, troque o arquivo.
//
// É um lockup completo (marca + palavra), 562×111 — proporção ~5:1. Por isso a
// prop é `height`: fixar largura distorceria ou exigiria recalcular a altura a
// cada uso.

const RATIO = 562 / 111;

export function LogoMark({ height = 18 }) {
  return (
    <img
      src="/logo.svg"
      alt=""
      aria-hidden="true"
      width={Math.round(height * RATIO)}
      height={height}
      style={{ display: "block", height, width: "auto" }}
      // O logo aparece acima da dobra em toda página: carregar com prioridade
      // evita o buraco na subnav no primeiro paint.
      fetchPriority="high"
      decoding="async"
    />
  );
}

export default function Logo({ height = 20 }) {
  return (
    <div className="nav-logo">
      <LogoMark height={height} />
    </div>
  );
}
